import request from '@/utils/request';
/**获取列表数据 */
export function logList(data) {
  return request.post('admin/customer/log/list', data);
}